import { ThunkDispatch, Action } from '@reduxjs/toolkit'
import { ErrorType, RequestErrorResponseFields } from '../../services/lib'
import { logoutUser } from '../slices/sessionSlice'

interface NetworkRequestError {
  code: ErrorType
  fields: RequestErrorResponseFields
  message: string
  name: string
}

export const processError = <S, E, A extends Action<any>>(
  e: unknown,
  dispatch: null | ThunkDispatch<S, E, A>
) => {
  const error = formatError(e)

  if (
    typeof error === 'object' &&
    (error as NetworkRequestError).code == 'auth' &&
    dispatch
  ) {
    dispatch(logoutUser())
  }
  return error
}

export const formatError = (e) => {
  // Define the typeguard function
  const isNetworkRequestError = (e: any): e is NetworkRequestError => {
    return (
      typeof e === 'object' &&
      e !== null &&
      'code' in e &&
      'fields' in e &&
      'message' in e &&
      'name' in e &&
      (e.code === 'error' || e.code === 'invalid' || e.code === 'auth') &&
      typeof e.message === 'string' &&
      typeof e.name === 'string' &&
      e.name == 'NetworkRequestError'
    )
  }

  const buildError = (e) => {
    const errorObject: NetworkRequestError = {
      code: 'error',
      fields: [],
      message: 'Request Error',
      name: 'NetworkRequestError'
    }

    if (typeof e === 'object' && e !== null) {
      errorObject.code = 'code' in e ? e.code : 'error'
      errorObject.fields = 'fields' in e ? e.fields : []
      errorObject.message = 'message' in e ? e.message : 'Request Error'
      errorObject.name = 'name' in e ? e.name : 'NetworkRequestError'
    }
    // Escapes the NetworkRequestError object so payload data can be serialized by redux
    return JSON.parse(JSON.stringify(errorObject))
  }

  if (isNetworkRequestError(e)) {
    // Escapes the NetworkRequestError object so payload data can be serialized by redux
    return JSON.parse(JSON.stringify(e))
  } else {
    return buildError(e)
  }
}
